import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-activate',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss'],
  host: { 'class': 'w-full block' }
})
export class ActivateComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  status: 'loading' | 'success' | 'error' = 'loading';
  errorMessage = '';

  ngOnInit(): void {
    const uid = this.route.snapshot.paramMap.get('uid');
    const token = this.route.snapshot.paramMap.get('token');

    if (uid && token) {
      this.authService.activate(uid, token).subscribe({
        next: () => {
          this.status = 'success';
        },
        error: (err) => {
          this.status = 'error';
          this.errorMessage = err.error?.detail || 'Activation failed. The link may be expired or invalid.';
        }
      });
    } else {
      this.status = 'error';
      this.errorMessage = 'Invalid activation link.';
    }
  }
}
